module.exports = __webpack_public_path__ + "img/download.cc31f08a.png";